const videoEnhancer = {
  HitPawOnlineAIVideoEnhance: 'HitPaw Online AI Video Enhance',
  ProcessingLimit: 'Limite de traitement :{{num}}',
  AllModelsAreAvailable: 'Tous les modèles sont disponibles',
  SupportAllSubdivisionRateExport:
    "Prise en charge de l'exportation de toutes les résolutions",
  SupportPreviewVideo: 'Prise en charge de la prévisualisation vidéo',
  BatchProcessingComingSoon: 'Traitement par lots (à venir)',
  CancelAnytime: "Annuler l'abonnement à tout moment",
  highPriorityProcessingSpeed: 'Vitesse de traitement prioritaire',
  YearDayPrice: '0.47€',
  YearTotalPrice: '169.99€',
  MonthTotalPrice: '23.99€',
  MonthDayPrice: '0.80€',
  WeekTotalPrice: '8.99€',
  WeekDayPrice: '1.28€',
  Day: 'Jour',
  Monthly: 'Mois',
  Weekly: 'Semaine',
  Yearly: 'Année',
};

export default videoEnhancer;
